import { NavLink } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
  LayoutDashboard, Users, Briefcase, Mail, ShieldCheck, LogOut, KeyRound
} from "lucide-react";

const NAV_ITEMS = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/users", label: "Users", icon: Users },
  { to: "/jobs", label: "Jobs", icon: Briefcase },
  { to: "/waitlist", label: "Waitlist", icon: Mail },
  { to: "/passcode", label: "Passcodes", icon: KeyRound },
  { to: "/admins", label: "Admins", icon: ShieldCheck, superadminOnly: true },
];

export default function Sidebar({ collapsed }) {
  const { user, logout } = useAuth();
  const width = collapsed ? 64 : 220;

  const items = NAV_ITEMS.filter(
    (item) => !item.superadminOnly || user?.role === "superadmin"
  );

  return (
    <aside style={{
      width, minWidth: width, background: "#1a1f2e",
      display: "flex", flexDirection: "column",
      transition: "width 0.2s ease, min-width 0.2s ease",
      position: "sticky", top: 0, height: "100vh", overflow: "hidden"
    }}>
      {/* Logo */}
      <div style={{
        padding: collapsed ? "18px 12px" : "20px 18px",
        display: "flex", justifyContent: "center", alignItems: "center",
        borderBottom: "1px solid rgba(255,255,255,0.08)", minHeight: 72
      }}>
        <div style={{
          background: "#ffffff", borderRadius: 10,
          padding: collapsed ? "5px 6px" : "8px 14px",
          display: "flex", alignItems: "center", justifyContent: "center"
        }}>
          <img
            src="/logo.png"
            alt="TheHealthHire Admin"
            style={{
              height: collapsed ? 26 : 36, width: "auto",
              maxWidth: "100%", objectFit: "contain"
            }}
          />
        </div>
      </div>

      {/* Nav */}
      <nav style={{ flex: 1, padding: "14px 10px", display: "flex", flexDirection: "column", gap: 4 }}>
        {items.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            title={collapsed ? label : undefined}
            style={({ isActive }) => ({
              display: "flex", alignItems: "center", gap: 12,
              justifyContent: collapsed ? "center" : "flex-start",
              padding: collapsed ? "11px 0" : "11px 14px",
              borderRadius: 10, textDecoration: "none",
              fontSize: 13.5, fontWeight: 600,
              color: isActive ? "#ffffff" : "#8b94a7",
              background: isActive ? "#1976e0" : "transparent",
              transition: "background 0.15s, color 0.15s"
            })}
          >
            <Icon size={18} style={{ flexShrink: 0 }} />
            {!collapsed && <span>{label}</span>}
          </NavLink>
        ))}
      </nav>

      {/* User + logout */}
      <div style={{
        borderTop: "1px solid rgba(255,255,255,0.08)",
        padding: collapsed ? "14px 8px" : "14px 16px"
      }}>
        {!collapsed && (
          <div style={{ marginBottom: 10 }}>
            <p style={{
              color: "#fff", fontSize: 13, fontWeight: 700,
              overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"
            }}>
              {user?.name}
            </p>
            <p style={{
              color: "#8b94a7", fontSize: 11, fontWeight: 600,
              textTransform: "uppercase", letterSpacing: "0.06em", marginTop: 2
            }}>
              {user?.role}
            </p>
          </div>
        )}
        <button
          onClick={logout}
          title="Logout"
          style={{
            display: "flex", alignItems: "center", gap: 8,
            justifyContent: collapsed ? "center" : "flex-start",
            width: "100%", background: "rgba(255,255,255,0.06)",
            border: "none", borderRadius: 8, cursor: "pointer",
            padding: collapsed ? "10px 0" : "9px 12px",
            color: "#8b94a7", fontSize: 12.5, fontWeight: 600
          }}
          onMouseEnter={(e) => { e.currentTarget.style.color = "#fff"; }}
          onMouseLeave={(e) => { e.currentTarget.style.color = "#8b94a7"; }}
        >
          <LogOut size={16} style={{ flexShrink: 0 }} />
          {!collapsed && "Logout"}
        </button>
      </div>
    </aside>
  );
}
